import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidePage from "@/pages/guide/page";
import TopicsPage from "@/pages/topics/page";
import TopicDetailPage from "@/pages/topics/detail/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "guide", element: <GuidePage /> },
      { path: "topics", element: <TopicsPage /> },
      { path: "topics/:id", element: <TopicDetailPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;